import {createFeatureSelector, createSelector} from '@ngrx/store'
import {IMenu} from './menu.state'

export const menuFeature = createFeatureSelector<{ menu: IMenu[] }>('menu')
export const selectMenu = createSelector(menuFeature, (state: { menu: IMenu[] }) => state.menu)
